import { INTEGRATION_LIST } from "./components/constants";
import {
  type Integration,
  type Integrations,
  type IntegrationConnectionState,
} from "./hooks";

export const hasIntegration = (
  integrations: Integration[],
  integrationConnectionStates: IntegrationConnectionState[],
  excludedIntegrations: string[] = []
) => {
  const allowedIntegrations = INTEGRATION_LIST.filter(
    (integration) => !excludedIntegrations.includes(integration)
  );

  return (
    !!integrations.find(
      (integration) =>
        allowedIntegrations.includes(integration.integration as Integrations) &&
        integration.status === "ACTIVE"
    ) ||
    integrationConnectionStates.some((connection) =>
      ["COMPLETED", "CONNECTED"].includes(connection.state || "")
    )
  );
};

export const hasAbandonedCartIntegration = (
  integrations: Integration[],
  integrationConnectionStates: IntegrationConnectionState[]
) => hasIntegration(integrations, integrationConnectionStates, ["woocommerce"]);
